'use strict'

import tooltipV2 from '@ui/Tooltip/component'

export default function (element: HTMLElement): void {
  const iconEl = element.querySelector<HTMLElement>('.label>i')
  const tooltipEl = element.querySelector<HTMLElement>('.tooltip')

  if (iconEl && tooltipEl) {
    tooltipV2(iconEl, tooltipEl)
  }
}
